import PDFBuilder, { fmtDate, fmtDateFromISO } from "../../utils/pdfBuilder.js";

const tipPretLabels = { fix: "fixa", ora: "pe ora", zi: "pe zi", luna: "pe luna" };
const termenPlataLabels = {
  finalizare: "la finalizarea serviciilor",
  lunar: "lunar, pana la data de 15 a lunii urmatoare",
  factura15: "in termen de 15 zile de la emiterea facturii",
  factura30: "in termen de 30 zile de la emiterea facturii",
};
const instantaLabels = {
  domiciliu_prestator: "instantele judecatoresti competente de la domiciliul/sediul prestatorului",
  domiciliu_beneficiar: "instantele judecatoresti competente de la domiciliul/sediul beneficiarului",
  executare: "instantele judecatoresti competente de la locul executarii contractului",
};

export default function buildPrestariServiciiPDF(data, filename) {
  const pdf = new PDFBuilder();
  const today = fmtDate(new Date());

  const pretText = `${data.pretSuma || "___"} ${data.pretMoneda || "RON"}${data.tipPret !== "fix" ? ` / ${tipPretLabels[data.tipPret] || ""}` : ""}`;

  // Header
  pdf.title("Contract de Prestari Servicii", `Nr. ${data.numarContract || "____"} din ${today}`);

  // I. PARTILE CONTRACTANTE
  pdf.section("I. PARTILE CONTRACTANTE");

  pdf.pMixed([{ text: "1.1. Prestatorul:", bold: true }]);
  pdf.renderPartyTip(data, "prestator");

  pdf.italic("si");

  pdf.pMixed([{ text: "1.2. Beneficiarul:", bold: true }]);
  pdf.renderPartyTip(data, "beneficiar");

  pdf.intro("au convenit incheierea prezentului contract de prestari servicii in urmatoarele conditii:");

  // II. OBIECTUL CONTRACTULUI
  pdf.section("II. OBIECTUL CONTRACTULUI");

  pdf.article("2.1.", "Prestatorul se obliga sa presteze in favoarea Beneficiarului urmatoarele servicii:");
  pdf.pMixed([{ text: data.obiectContract || "________________________", bold: true }], { indent: 5 });

  pdf.article("2.2.", "Serviciile vor fi prestate conform standardelor profesionale aplicabile si in conformitate cu specificatiile agreate de parti.");

  // III. DURATA CONTRACTULUI
  pdf.section("III. DURATA CONTRACTULUI");

  if (data.durataNedeterminata) {
    pdf.pMixed([
      { text: "3.1. ", bold: true },
      { text: "Prezentul contract se incheie pe " },
      { text: "durata nedeterminata", bold: true },
      { text: ", incepand cu data de " },
      { text: fmtDateFromISO(data.dataInceput), bold: true },
      { text: "." },
    ]);

    pdf.pMixed([
      { text: "3.2. ", bold: true },
      { text: "Oricare dintre parti poate denunta unilateral contractul cu un preaviz de " },
      { text: `${data.preavizReziliere || "30"} zile`, bold: true },
      { text: "." },
    ]);
  } else {
    pdf.pMixed([
      { text: "3.1. ", bold: true },
      { text: "Prezentul contract se incheie pe " },
      { text: "durata determinata", bold: true },
      { text: ", incepand cu data de " },
      { text: fmtDateFromISO(data.dataInceput), bold: true },
      { text: " si pana la data de " },
      { text: fmtDateFromISO(data.dataSfarsit), bold: true },
      { text: "." },
    ]);

    pdf.pMixed([
      { text: "3.2. ", bold: true },
      { text: "Contractul poate fi prelungit prin acordul scris al ambelor parti." },
    ]);
  }

  // IV. PRETUL SI MODALITATEA DE PLATA
  pdf.section("IV. PRETUL SI MODALITATEA DE PLATA");

  pdf.pMixed([
    { text: "4.1. ", bold: true },
    { text: "Pretul serviciilor este de " },
    { text: pretText, bold: true },
    { text: data.tipPret === "fix" ? "." : `, suma ${tipPretLabels[data.tipPret] || ""}.` },
  ]);

  pdf.pMixed([
    { text: "4.2. ", bold: true },
    { text: "Plata se efectueaza " },
    { text: termenPlataLabels[data.termenPlata] || "conform intelegerii partilor", bold: true },
    { text: "." },
  ]);

  pdf.article("4.3.", "Plata se face prin transfer bancar sau numerar, cu respectarea plafonului platilor in numerar conform Legii 70/2015.");

  pdf.article("4.4.", "Intarzierea la plata atrage penalitati de 0.1% pe zi din suma datorata, incepand cu ziua urmatoare scadentei.");

  // V. OBLIGATIILE PRESTATORULUI
  pdf.section("V. OBLIGATIILE PRESTATORULUI");

  const obligatiiPrestatorList = [
    "Sa presteze serviciile conform specificatiilor convenite in prezentul contract.",
    "Sa respecte termenele stabilite pentru executarea serviciilor.",
    "Sa informeze Beneficiarul cu privire la stadiul executarii serviciilor.",
    "Sa predea Beneficiarului rezultatele serviciilor prestate.",
    "Sa pastreze confidentialitatea informatiilor primite de la Beneficiar.",
  ];
  obligatiiPrestatorList.forEach((text, i) => {
    pdf.pMixed([
      { text: `5.${i + 1}. `, bold: true },
      { text },
    ], { indent: 5 });
  });

  // VI. OBLIGATIILE BENEFICIARULUI
  pdf.section("VI. OBLIGATIILE BENEFICIARULUI");

  const obligatiiBeneficiarList = [
    "Sa puna la dispozitia Prestatorului toate informatiile si documentele necesare executarii serviciilor.",
    "Sa plateasca pretul convenit la termenele stabilite.",
    "Sa receptioneze serviciile prestate si sa comunice observatiile in termen de 5 zile lucratoare.",
    "Sa nu utilizeze rezultatele serviciilor in alt scop decat cel convenit in prezentul contract.",
  ];
  obligatiiBeneficiarList.forEach((text, i) => {
    pdf.pMixed([
      { text: `6.${i + 1}. `, bold: true },
      { text },
    ], { indent: 5 });
  });

  // VII. RECEPTIA SERVICIILOR
  pdf.section("VII. RECEPTIA SERVICIILOR");

  pdf.pMixed([
    { text: "7.1. ", bold: true },
    { text: "La finalizarea serviciilor, Prestatorul va notifica Beneficiarul in vederea receptionarii." },
  ], { indent: 5 });

  pdf.pMixed([
    { text: "7.2. ", bold: true },
    { text: "Beneficiarul are la dispozitie 5 zile lucratoare pentru a verifica si receptiona serviciile prestate." },
  ], { indent: 5 });

  pdf.pMixed([
    { text: "7.3. ", bold: true },
    { text: "In cazul in care Beneficiarul nu formuleaza obiectiuni in termenul mentionat, serviciile se considera receptionate." },
  ], { indent: 5 });

  // VIII. INCETAREA CONTRACTULUI
  pdf.section("VIII. INCETAREA CONTRACTULUI");

  pdf.article("8.1.", "Contractul inceteaza:");

  const incetareItems = [
    ...(data.durataNedeterminata ? [] : ["la expirarea duratei"]),
    "prin acordul partilor",
    "prin reziliere pentru neexecutarea obligatiilor contractuale",
    `prin denuntare unilaterala cu preaviz de ${data.preavizReziliere || "30"} zile`,
  ];
  incetareItems.forEach((text, i) => {
    pdf.letterItem("abcd"[i], text);
  });

  pdf.article("8.2.", "In cazul rezilierii din culpa uneia dintre parti, partea in culpa datoreaza daune-interese celeilalte parti.");

  // Dynamic sections — Roman numerals for headings, Arabic for articles
  const roman = ["IX", "X", "XI", "XII", "XIII", "XIV", "XV"];
  let s = 0;
  let a = 9; // Arabic article counter, continues from section VIII

  // Confidentialitate (optional)
  if (data.includeNDA) {
    const heading = roman[s++];
    const n = a++;
    pdf.section(`${heading}. CONFIDENTIALITATE`);

    pdf.pMixed([
      { text: `${n}.1. `, bold: true },
      { text: "Partile se obliga sa pastreze confidentialitatea tuturor informatiilor, documentelor si datelor la care au acces in executarea prezentului contract." },
    ], { indent: 5 });

    pdf.pMixed([
      { text: `${n}.2. `, bold: true },
      { text: "Obligatia de confidentialitate se mentine pe toata durata contractului si pentru o perioada de 2 ani de la incetarea acestuia." },
    ], { indent: 5 });

    pdf.pMixed([
      { text: `${n}.3. `, bold: true },
      { text: "Nu constituie incalcarea obligatiei de confidentialitate dezvaluirea informatiilor la cererea autoritatilor competente, in conditiile legii." },
    ], { indent: 5 });
  }

  // Non-Concurenta (optional)
  if (data.includeNonCompete) {
    const heading = roman[s++];
    const n = a++;
    pdf.section(`${heading}. NON-CONCURENTA`);

    pdf.pMixed([
      { text: `${n}.1. `, bold: true },
      { text: "Pe durata contractului si pentru o perioada de 6 luni de la incetarea acestuia, Prestatorul se obliga sa nu presteze servicii identice sau similare in favoarea concurentilor directi ai Beneficiarului, fara acordul scris al acestuia." },
    ], { indent: 5 });

    pdf.pMixed([
      { text: `${n}.2. `, bold: true },
      { text: "Clauza de non-concurenta este limitata la domeniul de activitate si aria geografica in care Beneficiarul isi desfasoara activitatea." },
    ], { indent: 5 });

    pdf.pMixed([
      { text: `${n}.3. `, bold: true },
      { text: "Incalcarea obligatiei de non-concurenta da dreptul Beneficiarului la daune-interese." },
    ], { indent: 5 });
  }

  // Proprietate Intelectuala (always)
  {
    const heading = roman[s++];
    const n = a++;
    pdf.section(`${heading}. PROPRIETATE INTELECTUALA`);

    if (data.transferPI) {
      pdf.pMixed([
        { text: `${n}.1. `, bold: true },
        { text: "Drepturile de proprietate intelectuala asupra rezultatelor serviciilor prestate se transfera Beneficiarului la momentul platii integrale a pretului." },
      ], { indent: 5 });

      pdf.pMixed([
        { text: `${n}.2. `, bold: true },
        { text: "Prestatorul pastreaza dreptul de a utiliza metodologiile, know-how-ul si instrumentele proprii dezvoltate anterior sau independent de prezentul contract." },
      ], { indent: 5 });
    } else {
      pdf.pMixed([
        { text: `${n}.1. `, bold: true },
        { text: "Drepturile de proprietate intelectuala asupra rezultatelor serviciilor prestate raman in proprietatea Prestatorului." },
      ], { indent: 5 });

      pdf.pMixed([
        { text: `${n}.2. `, bold: true },
        { text: "Beneficiarul primeste o licenta neexclusiva de utilizare a rezultatelor, in scopul pentru care au fost create." },
      ], { indent: 5 });
    }
  }

  // Raspundere (always)
  {
    const heading = roman[s++];
    const n = a++;
    pdf.section(`${heading}. RASPUNDERE`);

    pdf.pMixed([
      { text: `${n}.1. `, bold: true },
      { text: "Fiecare parte raspunde pentru prejudiciile cauzate celeilalte parti prin neindeplinirea sau indeplinirea necorespunzatoare a obligatiilor asumate." },
    ], { indent: 5 });

    pdf.pMixed([
      { text: `${n}.2. `, bold: true },
      { text: "Nici una dintre parti nu raspunde pentru neexecutarea obligatiilor cauzata de forta majora, conform legii." },
    ], { indent: 5 });
  }

  // Legea Aplicabila si Litigii (always)
  {
    const heading = roman[s++];
    const n = a++;
    pdf.section(`${heading}. LEGEA APLICABILA SI LITIGII`);

    pdf.pMixed([
      { text: `${n}.1. `, bold: true },
      { text: "Prezentul contract este guvernat de legea romana." },
    ], { indent: 5 });

    pdf.pMixed([
      { text: `${n}.2. `, bold: true },
      { text: `Litigiile se solutioneaza pe cale amiabila, iar in caz contrar de ${instantaLabels[data.instantaCompetenta] || "instantele judecatoresti competente"}.` },
    ], { indent: 5 });
  }

  // Dispozitii Finale (always)
  {
    const heading = roman[s++];
    const n = a++;
    pdf.section(`${heading}. DISPOZITII FINALE`);

    pdf.pMixed([
      { text: `${n}.1. `, bold: true },
      { text: "Orice modificare a prezentului contract se face prin act aditional semnat de ambele parti." },
    ], { indent: 5 });

    pdf.pMixed([
      { text: `${n}.2. `, bold: true },
      { text: "Prezentul contract s-a incheiat in 2 exemplare originale, cate unul pentru fiecare parte." },
    ], { indent: 5 });
  }

  // Signatures
  pdf.signatures(
    { role: "PRESTATOR", name: pdf.getPartyNameTip(data, "prestator"), date: today },
    { role: "BENEFICIAR", name: pdf.getPartyNameTip(data, "beneficiar"), date: today },
  );

  pdf.save(filename);
}
